var productNameMapping = {
    ctm: 'Route Monitoring',
    ja: 'Junction Analytics',
    ll: 'Move',
    od: 'O/D Analysis',
    'rer-test': 'Road Event Reporter Test',
    rer: 'Road Event Reporter',
    ts: 'Traffic Stats',
    tv: 'Traffic Viewer',
};
export function getProductName(productId) {
    var mappingKey = Object.keys(productNameMapping).find(function (key) {
        return productId.startsWith(key);
    });
    if (!mappingKey) {
        throw new Error("Unknown product id \"".concat(productId, "\"."));
    }
    return productNameMapping[mappingKey];
}
//# sourceMappingURL=getProductName.js.map